import * as Filter  from './multiselect-filter';
import * as Sort    from './sort';
import * as SubMenu from './partner-menu';
import {SearchUrl}  from './partner-search-url';

const searchButtonElm   = document.getElementById('search-button') as HTMLButtonElement;
let searchUrl           = new SearchUrl(searchButtonElm.dataset.href);
searchButtonElm.addEventListener('click', () => window.location.href = searchUrl.getUrl());

// Init widgets
Filter.init(searchUrl);
Sort.init(searchUrl);

// Init sub menu
SubMenu.partnerSelectionMenu();
SubMenu.partnerSelectionScroll(); 


function attachClickHandlerToExtensionButton() {
  const extensionLabel = <HTMLElement> document.getElementById('select-extended-search-label');
  const extensionLine = <HTMLElement> document.getElementById('select-extended-search-line');
  const extensionConatainer = <HTMLElement> document.getElementById('select-extended-search-container');

  // Exit if there is not extended search
  if (extensionLabel == null) return;

  extensionLabel.addEventListener('click', () => {
    extensionLabel.classList.toggle('extended-search-open');
    extensionConatainer.classList.toggle('extended-search-open');
    extensionLine.classList.toggle('extended-search-open');
  });
  extensionLabel.addEventListener('keypress', (event) => {
    if (event.key == 'Enter') {
      extensionLabel.classList.toggle('extended-search-open');
      extensionConatainer.classList.toggle('extended-search-open');
      extensionLine.classList.toggle('extended-search-open');
      event.stopPropagation();
    }
  });
}
attachClickHandlerToExtensionButton()
